module.exports = __webpack_public_path__ + "static/media/CC-COL15_1Ama-4Szg7soqzvzz99qowe8usVKU-vYn.477fff68.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/CC-COL15_1Ama-4Szg7soqzvzz99qowe8usVKU-vYn
// module id = 774
// module chunks = 0